import { TColorScheme } from "../colors.types";

export const getAntLightTheme = (colors: TColorScheme) => {
  return {
    hashed: false,
    token: {
      colorPrimary: colors.primary[500],
      colorSuccess: colors.primary[500],
      colorError: colors.error[500],
      colorWarning: colors.warning[500],
      colorBgBase: colors.white,
      fontFamily: "Inter",
      borderRadius: 6,
    },
    components: {
      Layout: {
        headerBg: "transparent",
        bodyBg: colors.neutral[100],
        siderBg: colors.white,
        triggerBg: "transparent",
        triggerColor: colors.neutral[800],
      },
      Menu: {
        margin: 8,
        itemMarginInline: 0,
        subMenuItemBg: "transparent",
        itemColor: colors.neutral[1100],
      },
      Popover: {
        colorBgElevated: colors.white,
      },
      Input: {
        controlHeight: 44,
        controlHeightLG: 54,
        controlHeightSM: 36,
        colorBorder: colors.neutral[300],
        colorTextPlaceholder: colors.neutral[500],
        hoverBorderColor: colors.neutral[400],
        activeBorderColor: colors.neutral[500],
        colorPrimaryActive: colors.neutral[400],
        colorPrimaryHover: colors.neutral[500],
        activeShadow: "0 0 0 2px rgba(169, 185, 198, 0.1)",
      },
      InputNumber: {
        controlHeight: 44,
        controlHeightLG: 54,
        controlHeightSM: 36,
        colorBorder: colors.neutral[300],
        colorTextPlaceholder: colors.neutral[500],
        hoverBorderColor: colors.neutral[400],
        activeBorderColor: colors.neutral[500],
        colorPrimaryActive: colors.neutral[400],
        colorPrimaryHover: colors.neutral[500],
        activeShadow: "0 0 0 2px rgba(169, 185, 198, 0.1)",
      },
      Radio: {
        colorBorder: colors.neutral[200],
        colorPrimary: colors.neutral[200],
        colorPrimaryHover: colors.neutral[300],
        buttonSolidCheckedColor: colors.neutral[1100],
        buttonSolidCheckedHoverBg: colors.neutral[300],
        controlHeight: 44,
        controlHeightSM: 36,
      },
      Form: {
        labelHeight: 36,
      },
      Card: {
        colorBorderSecondary: "transparent",
        borderRadiusLG: 16,
        paddingLG: 20,
        headerHeight: 76,
      },
      Modal: {
        contentBg: colors.white,
        footerBg: colors.white,
        headerBg: colors.white,
      },
      Select: {
        colorFillTertiary: colors.white,
        controlHeight: 44,
        controlHeightLG: 54,
        controlHeightSM: 36,
        borderRadius: 8,
        colorBorder: colors.neutral[300],
        colorTextPlaceholder: colors.neutral[500],
        colorTextQuaternary: colors.neutral[1000],
      },
      DatePicker: {
        colorFillTertiary: colors.white,
        controlHeight: 44,
        controlHeightLG: 54,
        controlHeightSM: 36,
        colorTextDisabled: colors.neutral[1000],
      },
      Checkbox: {
        colorBorder: colors.neutral[200],
        colorBgContainer: colors.white,
        colorWhite: colors.white,
        colorPrimary: colors.neutral[1000],
        colorPrimaryHover: colors.neutral[800],
      },
      Button: {
        contentFontSizeSM: 14,
        onlyIconSize: 20,
        onlyIconSizeSM: 16,
        onlyIconSizeLG: 24,
        paddingInlineSM: 16,
        paddingInlineLG: 32,
        paddingInline: 24,
        controlHeightSM: 36,
        controlHeight: 44,
        controlHeightLG: 56,
        fontSize: 14,
        lineWidth: 1,
        marginXS: 8,
        borderRadiusSM: 6,
        borderRadius: 8,
        borderRadiusLG: 10,
        colorBorder: colors.neutral[300],
        defaultColor: colors.neutral[1100],
        colorLink: colors.primary[500],
        colorLinkActive: colors.primary[600],
        colorLinkHover: colors.primary[400],
        colorBgSolid: colors.neutral[1000],
        colorBgSolidActive: colors.neutral[1100],
        colorBgSolidHover: colors.neutral[900],
      },
      Table: {
        headerBg: "transparent",
        colorBgContainer: "transparent",
        colorSplit: "rgba(56, 6, 6, 0.03)",
        cellFontSize: 14,
        cellFontSizeMD: 16,
        cellFontSizeSM: 14,
        cellPaddingBlock: 16,
        cellPaddingInline: 20,
        fontSize: 14,
        fontSizeIcon: 12,
        fontSizeSM: 12,
        lineWidth: 1,
        marginXXS: 4,
        paddingXXS: 4,
        headerBorderRadius: 12,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        selectionColumnWidth: 48,
      },
      Tooltip: {
        colorBgSpotlight: colors.neutral[1100],
        colorTextLightSolid: colors.white,
        borderRadius: 8,
        sizePopupArrow: 20,
        paddingSM: 24,
        paddingXS: 20,
      },
      Dropdown: {
        colorBgElevated: colors.neutral[100],
        boxShadowSecondary: `0px 0px 0px 1px ${colors.neutral[300]}`,
      },
      Pagination: {
        controlHeightSM: 36,
      },
      Tabs: {
        itemColor: colors.neutral[600],
        inkBarColor: colors.neutral[1100],
        itemActiveColor: colors.neutral[900],
        itemHoverColor: colors.neutral[700],
        itemSelectedColor: colors.neutral[1100],
      },
      Result: {
        titleFontSize: 20,
        lineHeightHeading3: 1.4,
      },
      Switch: {
        innerMinMargin: 7,
        innerMaxMargin: 22,
      },
      Carousel: {
        colorBgContainer: colors.neutral[600],
      },
      Typography: {
        colorLink: colors.primary[500],
        colorLinkActive: colors.primary[600],
        colorLinkHover: colors.primary[400],
      },
      Segmented: {
        controlHeight: 44,
        controlHeightSM: 36,
        borderRadius: 12,
        borderRadiusSM: 8,
        trackPadding: 4,
        trackBg: colors.neutral[200],
      },
    },
  };
};
